import React, { FC } from "react";
import { IconWithTooltip } from "components/Elements/Icon/Icon";

interface MailTypeI {
  isJForm?: boolean;
  isJMail?: boolean;
  isJPay?: boolean;
  isJPicker?: boolean;
}

const MailType: FC<MailTypeI> = (props) => {
  const { isJForm, isJMail, isJPicker, isJPay } = props;

  return (
    <div className="mail-type-wrapper">
      {isJMail && (
        <div className="mail-type-label-wrapper">
          <IconWithTooltip
            iconProps={{ name: "newInbox/Products/mail", large: true }}
            tooltipProps={{
              tooltipText: "JUMBOMail",
            }}
          />
        </div>
      )}
      {isJForm && (
        <div className="mail-type-label-wrapper">
          <IconWithTooltip
            iconProps={{ name: "newInbox/Products/forms", large: true }}
            tooltipProps={{
              tooltipText: "JUMBOForms",
            }}
          />
        </div>
      )}
      {isJPicker && (
        <div className="mail-type-label-wrapper">
          <IconWithTooltip
            iconProps={{ name: "newInbox/Products/picker", large: true }}
            tooltipProps={{
              tooltipText: "JUMBOPicker",
            }}
          />
        </div>
      )}
      {isJPay && (
        <div className="mail-type-label-wrapper">
          <IconWithTooltip
            iconProps={{ name: "newInbox/Products/pay", large: true }}
            tooltipProps={{
              tooltipText: "JUMBOPay",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default MailType;
